import type { PatternProps } from "./shared";

export function CrossHatchPattern({ color, salt }: PatternProps) {
	/** Render */
	return (
		<defs>
			<pattern
				id={`${salt}-crosshatchPattern`}
				patternUnits="userSpaceOnUse"
				width="14"
				height="14"
			>
				<path
					d="M0,14 l14,-14 M-1.75,1.75 l3.5,-3.5 M12.25,15.75 l3.5,-3.5"
					stroke={color}
					strokeWidth="1.75"
				/>
				<path
					d="M0,0 l14,14 M-1.75,12.25 l3.5,3.5 M12.25,-1.75 l3.5,3.5"
					stroke={color}
					strokeWidth="1.75"
				/>
			</pattern>
		</defs>
	);
}
